<template>
	<span v-if="resourceType === ResourceType.image" class="text-truncate">
		<span>{{ source.anchor }}</span>
	</span>
	<span v-else-if="resourceType === ResourceType.link" class="text-truncate">
		<a
			class="link-secondary"
			:href="buildAnchorUrl(source.url, source.anchor || '')"
			target="_blank"
			rel="noopener noreferrer"
		>
			{{ source.anchor }}
		</a>
	</span>
</template>

<script lang="ts">
import { ResourceSource } from "@/services/resourceWatcherService";
import { buildAnchorUrl } from "@/utils";
import { ResourceType } from "@/utils/watcher";
import { defineComponent } from "vue";

export default defineComponent({
	props: {
		resourceType: {
			type: String as () => ResourceType,
			required: true,
		},
		source: {
			type: Object as () => ResourceSource,
			required: true,
		},
	},
	setup() {
		return { ResourceType, buildAnchorUrl };
	},
});
</script>
